















































































































































































































// @ts-nocheck
import TitleBar from "@/components/Elements/TitleBar.vue";

import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mapGetters, mapState, mapActions } from "vuex";

import { STORE_KEY, store } from "./_store";
import moment from "moment";

@Component({
  computed: {
    ...mapState(STORE_KEY, ["loading", "loaded", "fatalError", "data", "total"])
  },
  methods: {
    ...mapActions(STORE_KEY, ["setReportOptions", "exportDataAsXLSX"])
  },
  components: {
    TitleBar
  }
})
export default class MarginalityByProductReport extends Vue {
  get titleStack() {
    return ["Отчеты", "По маржинальности продуктов"];
  }

  localFilter = {
    with_container: null,
    product_types: null,
    targetDates: [new Date(), new Date()]
  };
  get withContainer() {
    return this.$route.query.with_container == "true";
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    // @ts-ignore
    this.localFilter.with_container =
      this.$route.query && this.$route.query.with_container
        ? this.$route.query.with_container
        : null;
    // @ts-ignore
    this.localFilter.product_types =
      this.$route.query && this.$route.query.product_types
        ? this.$route.query.product_types
        : [];
    this.localFilter.product_types = Array.isArray(
      this.localFilter.product_types
    )
      ? this.localFilter.product_types
      : [this.localFilter.product_types];
    // @ts-ignore
    // @ts-ignore
    this.localFilter.targetDates =
      this.$route.query && this.$route.query.targetDates
        ? [
            moment(this.$route.query.targetDates[0]).toDate(),
            moment(this.$route.query.targetDates[1]).toDate()
          ]
        : [new Date(), new Date()];

    this.handleParamsChange();
  }

  setFilterData() {
    const query = Object.keys(this.localFilter).reduce((ac: any, key) => {
      // @ts-ignore
      ac[key] =
        key == "targetDates"
          ? [
              moment(this.localFilter[key][0]).format("YYYY-MM-DD"),
              moment(this.localFilter[key][1]).format("YYYY-MM-DD")
            ]
          : this.localFilter[key];
      return ac;
    }, {});

    this.$router.replace({
      query
    });
  }

  // ---------------------------------------------------------------------------

  @Watch("$route.query")
  public handleParamsChange() {
    this.$store.dispatch(`${STORE_KEY}/loadData`, this.$route.query);
  }
}
